export default {
  // Paths
  PATH_NO_BLOG: "noBlog",
  PATH_BASIC_BLOG: "basicBlog",
  PATH_ADV_NEW: "advNew",
  PATH_ADV_MIGRATE: "advMigrate",

  // Views
  VIEW_DOMAIN_INFO: "DomainInfo",
  VIEW_BLOG_CHOICE: "BlogChoice",
  VIEW_MIGRATION_DETAILS: "MigrationDetails",
  VIEW_CONFIRM: "Confirm",
  VIEW_COMPLETE: "Complete",

  // configure_domain API values
  CONFIGURE_DOMAIN_NEW: "N",
  CONFIGURE_DOMAIN_MIGRATE: "M",

  // blog_admin_verified status values
  BLOG_VERIFIED_LOGIN: "login",
  BLOG_VERIFIED_INVALID: "invalid",
  BLOG_VERIFIED_USER: "user",

  // Default blog subpath appended to a domain (e.g. "example.com/blog")
  DEFAULT_BLOG_SUBPATH: "/blog",

  // Blog setup fields forwarded to updateBlogSetupRequest
  BLOG_SETUP_FIELDS: [
    "blog_url",
    "blog_domain_name",
    "blog_admin_url",
    "blog_admin_user",
    "blog_admin_pass",
    "blog_admin_verified",
    "blog_new_url",
  ],
};
